export default __webpack_public_path__ + "static/media/GitHub-profile-done.9a50ea66.png";